__turbopack_context__.v({
  "className": "geist_b7e8b517-module__QXu7mW__className",
  "variable": "geist_b7e8b517-module__QXu7mW__variable",
});
